var map = {
	"./demos/basic/index.ts": 62556,
	"./demos/button/index.ts": 37263,
	"./demos/content/index.ts": 26031,
	"./demos/text/index.ts": 67432,
	"./demos/type/index.ts": 91100
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84678;